import { savedOrderDetailsHeaderStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { borderBottomTitlesStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(savedOrderDetailsHeaderStyles, {
    headerGridContainer: {
        css: css`
            ${borderBottomTitlesStyles()};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [20, null, 40, null, null], properties: ["margin-bottom"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    buttonGridItem: {
        css: css`
            justify-content: flex-end;
        `,
        width: [2, 2, 5, 8, 8],
    },
    actionButtons: {
        buttonsHiddenContainer: {
            css: css`
                display: flex;
            `,
        },
        middleOverflowMenu: {
            cssOverrides: {
                wrapper: css`
                    display: inline;
                    margin-left: 20px;
                    vertical-align: middle;
                `,
            },
            buttonProps: {
                css: css`
                    width: auto;
                `,
            },
        },
        narrowOverflowMenu: {
            buttonProps: {
                css: css`
                    width: auto;
                `,
            },
        },
    },
    titleGridItem: {
        width: [10, 10, 7, 4, 4],
        css: css`
            align-items: center;
        `,
    },
});
